import { Button } from '@material-ui/core'

import { Auth } from 'aws-amplify'
import React, { FC } from 'react'

const SignOutButton: FC = () => {
  const handleSignOut = (): void => {
    void Auth.signOut()
  }

  return (
    <Button variant="outlined" size="large" onClick={() => handleSignOut()}>
      Sign Out
    </Button>
  )
}

export default SignOutButton
